<template>
  <div class="yb-view">
    <div class="yb-view-content">
      <NuxtPage />
    </div>
  </div>
</template>
